import Axios from "axios";

export const axiosInstance = Axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 20000,
});

axiosInstance.interceptors.response.use(
    function (response) {
        return response.data;
    },
    function (error) {
        if (error) {
            return {
                err: true,
            };
        }
    }
);

export const getTour = id => axiosInstance.get(`/tour/${id}`);

export const getProduct = id => axiosInstance.get(`/product/${id}`);

export const getTourDays = id => axiosInstance.get(`/tourDays/${id}`);

export const getDay = id => axiosInstance.get(`/day/${id}`);

export const getItineraries = id => axiosInstance.get(`/itineraries/${id}`);
